import React, { Component } from "react";
import Image from "../../assets/background.jpg";

import PropTypes from "prop-types";
import { connect } from "react-redux";

class Backdrop extends Component {
    constructor(props) {
        super(props)
    }
    static propTypes = {
        auth: PropTypes.object.isRequired,
    };

    render() {
        const isAuthenticated = this.props.auth.status === "authenticated";

        const guestBack = (
            <div className="w100 landing-back" ></div>
        )
        const authBack = (
            <div className="w100" style={{ backgroundColor: "#F2F2F3" }}>
            </div>
        )

        return (
            <div>
                { isAuthenticated ? authBack : guestBack}
            </div>
        )
    }
}


const mapStateToProps = (state) => ({
    auth: state.auth
});

export default connect(mapStateToProps)(Backdrop);